import React from "react";

const NOISE =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.82' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

const MONO = '"Plus Jakarta Sans", system-ui, sans-serif';

/**
 * Layered somatic/topographic background texture echoing bracednomore.info —
 * warm ochre + sage depth washes, faint contour "map" rings, film grain, and
 * cartographic coordinate markers. Sits behind page content (z-0).
 */
export const SomaticTexture = ({ coordinates = true }) => (
  <>
    {/* warm ochre + sage depth washes */}
    <div
      className="pointer-events-none fixed inset-0 z-0"
      aria-hidden="true"
      style={{
        background:
          "radial-gradient(92% 55% at 10% -8%, rgba(150,102,56,0.14), transparent 60%)," +
          "radial-gradient(78% 60% at 102% 12%, rgba(96,110,94,0.10), transparent 55%)," +
          "radial-gradient(70% 55% at 50% 114%, rgba(150,102,56,0.09), transparent 62%)",
      }}
    />
    {/* topographic contour rings */}
    <div
      className="pointer-events-none fixed inset-0 z-0"
      aria-hidden="true"
      style={{
        opacity: 0.55,
        backgroundImage:
          "repeating-radial-gradient(circle at 9% 16%, transparent 0 50px, rgba(212,163,115,0.06) 50px 51px, transparent 51px 100px)," +
          "repeating-radial-gradient(circle at 94% 86%, transparent 0 58px, rgba(152,168,152,0.05) 58px 59px, transparent 59px 118px)",
      }}
    />
    {/* film grain */}
    <div
      className="pointer-events-none fixed inset-0 z-0 opacity-[0.055]"
      aria-hidden="true"
      style={{ backgroundImage: NOISE }}
    />
    {/* cartographic coordinate markers */}
    {coordinates && (
      <>
        <span
          className="pointer-events-none fixed bottom-5 left-5 z-0 hidden text-[10px] uppercase tracking-[0.35em] sm:block"
          aria-hidden="true"
          style={{ color: "rgba(212,163,115,0.28)", fontFamily: MONO }}
        >
          N 48.1 · E 23.4
        </span>
        <span
          className="pointer-events-none fixed bottom-5 right-5 z-0 hidden text-[10px] uppercase tracking-[0.35em] sm:block"
          aria-hidden="true"
          style={{ color: "rgba(152,168,152,0.26)", fontFamily: MONO }}
        >
          04 // vault field · 3.1 mi
        </span>
      </>
    )}
  </>
);

export default SomaticTexture;
